type Environment = 'development' | 'production'

const SCRIPT_URLS = {
  development: 'https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-cc2440d362e4-development.min.js',
  production: 'https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-4aefa0b9df82.min.js',
}

const getScriptUrl = (env: Environment): string => {
  return SCRIPT_URLS[env] || SCRIPT_URLS.production
}

export const initAdobeDataLayerMMT = (env: Environment = 'development'): string => {
  const scriptUrl = getScriptUrl(env)
  return `<script src="${scriptUrl}" async></script>`
}

export const getAdobeScriptMMT = (env: Environment = 'development') => getScriptUrl(env)
